import { all } from 'redux-saga/effects';

import { handleSubmitFormSaga } from 'ackee-frontend-toolkit/es/modules/forms';
import { saga as routingHistory } from 'ackee-frontend-toolkit/lib/modules/routing-history';

// NOTE: localization saga handles:
// - loading of a stored locale
// - setting of a new locale (with setLocale(locale) action creator )
import { saga as localization } from 'ackee-frontend-toolkit/lib/modules/localization';

export default function* ackeeToolkit() {
    yield all([handleSubmitFormSaga(), localization(), routingHistory()]);
}
